"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconTable', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H2ZM5 3H3V5H5V3ZM7 5V3H13V5H7ZM5 7H3V9H5V7ZM7 9V7H13V9H7ZM5 11H3V13H5V11ZM7 13V11H13V13H7Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2V18C1 18.5523 1.44772 19 2 19H18C18.5523 19 19 18.5523 19 18V2C19 1.44772 18.5523 1 18 1H2ZM8 17H17V13.5H8V17ZM6 13.5V17H3V13.5H6ZM8 11.5H17V8.5H8V11.5ZM6 8.5V11.5H3V8.5H6ZM8 6.5H17V3H8V6.5ZM6 3V6.5H3V3H6Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M2 1C1.44772 1 1 1.44772 1 2V22C1 22.5523 1.44772 23 2 23H22C22.5523 23 23 22.5523 23 22V2C23 1.44772 22.5523 1 22 1H2ZM8 3H3V7.99999H8V3ZM10 7.99999V3H21V7.99999H10ZM8 9.99999H3V14.5H8V9.99999ZM10 14.5V9.99999H21V14.5H10ZM8 16.5H3V21H8V16.5ZM10 21V16.5H21V21H10Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M2.49997 0.999985C2.10215 0.999985 1.72061 1.15802 1.43931 1.43932C1.158 1.72063 0.999969 2.10216 0.999969 2.49998L0.999984 20.4932L0.999969 20.5L0.999984 20.5067L0.999992 29.5C0.999992 30.3284 1.67156 31 2.49999 31H29.5C30.3284 31 31 30.3284 31 29.5V2.50001C31 1.67158 30.3284 1.00001 29.5 1.00001L2.49997 0.999985ZM3.99999 28L3.99999 22H10.5V28H3.99999ZM13.5 28H28V22H13.5V28ZM13.5 19H28V13H13.5V19ZM13.5 10H28V4.00001L13.5 3.99999V10ZM10.5 3.99999V10H3.99998L3.99997 3.99999L10.5 3.99999ZM10.5 13V19H3.99998L3.99998 13H10.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;